const auditList = () => import('@/pages/community/audit/index.vue');

export default [{
    path: '/community/audit',
    component: auditList,
    meta: [{
        name: '社区管理'
    },
    {
        name: '待审核列表',
        activeRoute: '/community/audit'
    }]
}];